import { cn, Container, Section } from '@resolute/ui';

import { FOUR_UP_BORDERS } from '../grid-borders';

import { Reveal, StaggerGroup, StaggerItem } from '@/components/motion/reveal';

const PRINCIPLES = [
  {
    title: 'Verification Before Visibility',
    body: 'Every listing’s RERA registration and legal documents are checked before it ever appears in a search result — not after a buyer asks for them.',
  },
  {
    title: 'Numbers Over Brochures',
    body: 'Yield, ROI and price-trend figures are modelled from real transaction data, not copied from a developer’s marketing PDF.',
  },
  {
    title: 'One Journey, Wherever You Are',
    body: 'An NRI buyer gets the identical due-diligence trail, document access and advisor support as someone walking the site in person.',
  },
  {
    title: 'Outcomes Over Listing Count',
    body: 'We measure ourselves on verified closings and satisfied buyers — not on how many listings we can put on a page.',
  },
];

export function AboutPrinciples() {
  return (
    <Section spacing="md">
      <Container>
        <Reveal className="max-w-2xl">
          <p className="text-sm font-medium uppercase tracking-widest text-secondary">
            Founding principles
          </p>
          <h2 className="mt-2 text-balance font-display text-display-sm font-semibold tracking-tight">
            The beliefs that drive every listing we publish.
          </h2>
        </Reveal>

        <StaggerGroup className="mt-10 grid grid-cols-1 overflow-hidden rounded-lg border border-border sm:mt-12 sm:grid-cols-2">
          {PRINCIPLES.map((p, i) => (
            <StaggerItem key={p.title} className={cn('p-6', FOUR_UP_BORDERS[i])}>
              <span className="text-sm font-semibold text-secondary">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-3 text-xl font-semibold tracking-tight">{p.title}</h3>
              <p className="mt-2 text-muted-foreground">{p.body}</p>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </Container>
    </Section>
  );
}
